<template>
  <b-modal 
    v-model="localIsVisible" 
    size="md" 
    hide-footer 
    @cancel="onCancel"
  >
    <b-card title="Crear Imagen" class="my-0">
      <validation-observer v-slot="{ invalid }" ref="observer">
        <b-form @submit.prevent="submitForm">
          <b-form-group>
            <label>Nombre: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="nombre"
              rules="required"
            >
              <b-form-input
                id="nombre"
                :state="errors.length > 0 ? false : null"
                v-model="imagen.nombre"
                type="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="codigo">
            <label>Código: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="codigo"
              rules="required"
            >
              <b-form-input
                id="codigo"
                :state="errors.length > 0 ? false : null"
                v-model="imagen.codigo"
                type="text"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label-for="precioneto">
            <label>Precio: <span class="text-danger">*</span></label>
            <validation-provider
              #default="{ errors }"
              name="precioneto"
              rules="required"
            >
              <b-form-input
                id="precioneto"
                :state="errors.length > 0 ? false : null"
                v-model="imagen.precioNeto"
                type="text"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
              ></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="establecimiento">
            <label>
              Establecimiento: <span class="text-danger">*</span>
            </label>

            <validation-provider
              #default="{ errors }"
              name="establecimiento"
              rules="required"
            >
              <v-select
                id="establecimiento"
                v-model="imagen.establecimiento"
                placeholder="Buscar por establecimiento."
                :options="establecimientosOpts"
                :reduce="(option) => option.value"
                label="text"
                class="d-inline-block w-100"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label-for="tipoImagen">
            <label>
              Tipo de Imagen: <span class="text-danger">*</span>
            </label>
            <validation-provider
              #default="{ errors }"
              name="tipoImagen"
              rules="required"
            >
              <v-select
                id="tipoImagen"
                v-model="imagen.tipoImagen"
                placeholder="Buscar por tipo de imagen."
                :options="tipoImagenOpts"
                :reduce="(option) => option.value"
                label="text"
                class="d-inline-block w-100"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-button 
            type="submit" 
            variant="primary"
            class="mt-2"
          >
            Crear Imagen
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import axios   from "axios";
import rutas   from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from '@validations';
import { establecimientosService } from '@/views/administracion/services';
import { fetchTipoImagenSelect }       from '../services/tipoImagen';


export default {

  name: "ModalCrearImagen",

  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localIsVisible:false,

      required,

      establecimientosOpts: [],
      tipoImagenOpts:[],

      imagen: {
        id: "",
        nombre: "",
        codigo: "",
        precioNeto: 0,

        estado: "1",
      },
    };
  },
  async created() {
    this.establecimientosOpts = await establecimientosService.getForSelect();
    this.tipoImagenOpts = await fetchTipoImagenSelect();
  },

  methods: {
    onCancel() {
      this.localIsVisible = false
    },


    async submitForm() {
      const precioNetoFormateado = parseFloat(this.imagen.precioNeto).toFixed(4);

      const query = `
        mutation crearImagen($imagen: ImagenInput!) {
          crearImagen(imagen: $imagen) {
            imagenCreada {
              token
              id
            }
            status
            message
          }
        }
      `;

      const variables = {
        imagen: {
          codigo: this.imagen.codigo,
          nombre: this.imagen.nombre,
          precio: precioNetoFormateado,
          establecimiento: this.imagen.establecimiento,
          tipoImagen: this.imagen.tipoImagen,
          estado: this.imagen.estado,
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.crearImagen.status === "success") {

          this.localIsVisible = false;

          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La imagen se creó correctamente.",
          });

        } else {
          this.$swal({
            title: "Error",
            text: response.data.data.crearImagen.message,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear la imagen.",
        });
      }
    },
  },

  watch: {

    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }

  }
};
</script>